import { Injectable } from '@angular/core';
import { ApiProvider } from '../api/api';
import { Collection } from 'lokijs';
import moment from 'moment';
import { DatabaseProvider } from '../database/database';
import { AppState } from '../../config/state';

/*
  Generated class for the WidgetsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class WidgetsProvider {
  private widgetsCollection: Collection;

  constructor(private api: ApiProvider, private db :DatabaseProvider, private state: AppState) {
    this.widgetsCollection = this.db.getCollection('widgets');
    this.widgetsCollection.ensureUniqueIndex('id');
  }

  async getWidgetData(widgetId:Number) :Promise<Widget>{
    let data = this.widgetsCollection.findOne({ id: widgetId });
    if (data && moment().diff(data.cachedTime, 'seconds') < this.state.cacheTime) {
      return data;
    }

    const query = `{
      getWidget(id:${widgetId}){
        id, name, options, data, description, revision, lastUpdate, updatedBy, dontPreview
      }
    }`;

    data = await this.api.query(query);
    if(data && data.getWidget){
      const widget = data.getWidget;
      widget.cachedTime = moment().toISOString();
      this.widgetsCollection.chain().find({ id: widget.id }).remove();
      this.widgetsCollection.insertOne(widget);
      await this.db.saveDB();
      return widget;
    }else{
      return null;
    }
  };
}

export interface Widget {
  id: number;
  clientId: number;
  name?: string;
  options?: string;
  data: string;
  description?: string;
  revision?: number;
  lastUpdate?: string;
  updatedBy?: number;
  dontPreview?: boolean;
}


// WEBPACK FOOTER //
// ./src/providers/widgets/widgets.ts